export function modalMenu($) {

  const $burgerMenu = $('.menu-toggle');
  $burgerMenu.click(function (event) {
    event.preventDefault();
    $(this)
      .toggleClass('active');
    $('body')
      .toggleClass('visibleMenu');
  });

  $(document).on('click', function (event) {
    if (!$(event.target).closest('.menu-modal-inner').length && !$(event.target).is('.menu-modal-inner') && !$(event.target).closest('.menu-toggle').length && !$(event.target).is('.menu-toggle')) {
      if (!$('body').is('.visibleMenu')) return;
      $('.menu-toggle').removeClass('active');
      $('body').removeClass('visibleMenu ');
    }
  });

}